(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-journey"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'goofy-home-reviews-loop';
  if (customElements.get(tag)) return;

  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      this.track = this.querySelector('[data-carousel-track]');
      if (!this.track) return;

      this.slides = [
        ...this.track.querySelectorAll(
          '[data-carousel-slide]:not([data-goofy-clone])'
        )
      ];

      this.count = this.slides.length;
      if (!this.count) return;

      this.controller = new AbortController();
      const signal = this.controller.signal;

      const listen = (node, type, fn, options = {}) =>
        node?.addEventListener(type, fn, { ...options, signal });

      this.area = this.closest('.ap-review-section');
      this.dots = this.querySelector('[data-carousel-dots]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.hovered = false;
      this.inView = true;
      this.dragged = false;
      this.busy = false;
      this.pad = this.count > 1 ? 3 : 0;

      const clone = (slide) => {
        const copy = slide.cloneNode(true);
        copy.dataset.goofyClone = 'true';
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('tabindex', '-1');
        copy.removeAttribute('id');

        copy.querySelectorAll('[id]').forEach((node) => {
          node.removeAttribute('id');
        });

        copy.querySelectorAll(
          'a,button,input,select,textarea,iframe,video,[tabindex]'
        ).forEach((node) => {
          node.setAttribute('tabindex', '-1');
        });

        return copy;
      };

      if (this.pad) {
        this.track.prepend(
          ...Array.from({ length: this.pad }, (_, i) =>
            clone(
              this.slides[
                (
                  (this.count - this.pad + i) % this.count +
                  this.count
                ) % this.count
              ]
            )
          )
        );

        this.track.append(
          ...Array.from({ length: this.pad }, (_, i) =>
            clone(this.slides[i % this.count])
          )
        );
      }

      this.items = [
        ...this.track.querySelectorAll('[data-carousel-slide]')
      ];

      if (this.dots) {
        this.dots.replaceChildren(
          ...this.slides.map((_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.dataset.reviewDot = index;
            dot.setAttribute(
              'aria-label',
              `Go to review ${index + 1}`
            );
            return dot;
          })
        );
      }

      listen(
        this.area?.querySelector('[data-carousel-prev]'),
        'click',
        () => this.go(-1)
      );

      listen(
        this.area?.querySelector('[data-carousel-next]'),
        'click',
        () => this.go(1)
      );

      listen(this.dots, 'click', (event) => {
        const dot = event.target.closest('[data-review-dot]');
        if (dot) this.goTo(Number(dot.dataset.reviewDot));
      });

      listen(this.track, 'scroll', () => {
        if (this.busy || this.pointer) return;

        this.stop();
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.settle(), 200);
      }, { passive: true });

      listen(this.track, 'pointerdown', (event) => {
        if (
          this.busy ||
          event.target.closest(
            'a,button,iframe,video,input,select,textarea'
          )
        ) return;

        this.stop();
        this.dragged = false;

        this.pointer = {
          x: event.clientX,
          y: event.clientY,
          id: event.pointerId
        };
      }, { passive: true });

      listen(window, 'pointermove', (event) => {
        if (
          !this.pointer ||
          event.pointerId !== this.pointer.id
        ) return;

        if (
          Math.abs(event.clientX - this.pointer.x) > 8 ||
          Math.abs(event.clientY - this.pointer.y) > 8
        ) {
          this.dragged = true;
        }
      }, { passive: true });

      listen(window, 'pointerup', (event) => {
        if (
          !this.pointer ||
          event.pointerId !== this.pointer.id
        ) return;

        const dx = event.clientX - this.pointer.x;
        const dy = event.clientY - this.pointer.y;
        this.pointer = null;

        if (
          Math.abs(dx) > 30 &&
          Math.abs(dx) > Math.abs(dy)
        ) {
          this.go(dx < 0 ? 1 : -1);
        } else {
          this.start();
        }
      }, { passive: true });

      listen(window, 'pointercancel', () => {
        if (!this.pointer) return;

        this.pointer = null;
        this.dragged = true;
        this.start();
      }, { passive: true });

      listen(this.track, 'click', (event) => {
        const slide = event.target.closest('[data-review-url]');

        if (
          !slide ||
          this.dragged ||
          this.busy ||
          getSelection()?.toString()
        ) return;

        if (
          event.target.closest(
            'a,button,iframe,video,input,select,textarea'
          )
        ) return;

        window.open(
          slide.dataset.reviewUrl,
          '_blank',
          'noopener,noreferrer'
        );
      });

      listen(this.track, 'keydown', (event) => {
        const slide = event.target.closest('[data-review-url]');

        if (
          event.target !== this.track &&
          event.target !== slide
        ) return;

        if (
          event.key === 'ArrowRight' ||
          event.key === 'ArrowLeft'
        ) {
          event.preventDefault();
          this.go(event.key === 'ArrowRight' ? 1 : -1);
        } else if (
          slide &&
          (event.key === 'Enter' || event.key === ' ')
        ) {
          event.preventDefault();

          window.open(
            slide.dataset.reviewUrl,
            '_blank',
            'noopener,noreferrer'
          );
        }
      });

      listen(this, 'pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.stop();
      });

      listen(this, 'pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = false;
        this.start();
      });

      listen(this.area, 'focusin', () => this.stop());

      listen(this.area, 'focusout', () => {
        queueMicrotask(() => this.start());
      });

      listen(document, 'visibilitychange', () => this.start());
      listen(this.motion, 'change', () => this.start());

      this.resizeObserver = new ResizeObserver(() => {
        this.measure();
      });

      this.resizeObserver.observe(this.track);

      this.intersectionObserver = new IntersectionObserver(
        ([entry]) => {
          this.inView = entry.isIntersecting;
          this.start();
        }
      );

      this.intersectionObserver.observe(this);
      this.measure();
    }

    measure() {
      this.stop();
      cancelAnimationFrame(this.frame);
      this.busy = false;

      const origin = this.items[0].getBoundingClientRect().left;

      this.positions = this.items.map((slide) =>
        slide.getBoundingClientRect().left - origin
      );

      this.track.scrollLeft =
        this.positions[this.pad + this.index] || 0;

      this.updateDots();
      this.start();
    }

    settle() {
      if (this.busy || !this.positions?.length) return;

      const nearest = this.positions.reduce(
        (best, value, index) =>
          Math.abs(value - this.track.scrollLeft) <
          Math.abs(this.positions[best] - this.track.scrollLeft)
            ? index
            : best,
        0
      );

      this.index = (
        (nearest - this.pad) % this.count + this.count
      ) % this.count;

      this.track.scrollLeft =
        this.positions[this.pad + this.index];

      this.updateDots();
      this.start();
    }

    go(step) {
      if (this.busy || this.count < 2) return;
      this.animate(this.index + (step < 0 ? -1 : 1));
    }

    goTo(index) {
      if (
        this.busy ||
        index < 0 ||
        index >= this.count ||
        index === this.index
      ) return;

      this.animate(index);
    }

    animate(next) {
      this.stop();
      clearTimeout(this.scrollTimer);
      this.busy = true;

      const from = this.track.scrollLeft;
      const to = this.positions[this.pad + next];
      const duration = this.motion.matches ? 0 : 420;
      let started;

      const tick = (time) => {
        started ??= time;

        const progress = duration
          ? Math.min(1, (time - started) / duration)
          : 1;

        const eased = 1 - Math.pow(1 - progress, 3);

        this.track.scrollLeft =
          from + (to - from) * eased;

        if (progress < 1) {
          this.frame = requestAnimationFrame(tick);
          return;
        }

        this.index = (next + this.count) % this.count;

        this.track.scrollLeft =
          this.positions[this.pad + this.index];

        this.updateDots();

        this.frame = requestAnimationFrame(() => {
          this.busy = false;
          this.start();
        });
      };

      this.frame = requestAnimationFrame(tick);
    }

    updateDots() {
      this.dots?.querySelectorAll('button').forEach(
        (dot, index) => {
          dot.classList.toggle(
            'is-active',
            index === this.index
          );

          dot.setAttribute(
            'aria-current',
            index === this.index ? 'true' : 'false'
          );
        }
      );
    }

    start() {
      this.stop();

      if (
        this.count < 2 ||
        this.dataset.autoplay !== 'true' ||
        this.busy ||
        this.motion.matches ||
        document.hidden ||
        !this.inView ||
        this.hovered ||
        this.pointer ||
        this.area?.contains(document.activeElement)
      ) return;

      this.timer = setTimeout(
        () => this.go(1),
        Math.max(2000, Number(this.dataset.speed) || 5000)
      );
    }

    stop() {
      clearTimeout(this.timer);
    }

    disconnectedCallback() {
      this.stop();
      clearTimeout(this.scrollTimer);
      cancelAnimationFrame(this.frame);

      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.controller?.abort();

      this.track?.querySelectorAll(
        '[data-goofy-clone]'
      ).forEach((slide) => slide.remove());

      this.controller = null;
    }
  });
})();

(() => {
  const tag = 'goofy-home-hubspot';
  if (customElements.get(tag)) return;

  let loader;

  const load = () => {
    if (window.hbspt?.forms?.create) return Promise.resolve();
    if (loader) return loader;

    loader = new Promise((resolve, reject) => {
      const script = document.createElement('script');

      script.src = 'https://js.hsforms.net/forms/embed/v2.js';
      script.charset = 'utf-8';
      script.async = true;

      script.onload = () => {
        if (window.hbspt?.forms?.create) {
          resolve();
        } else {
          reject();
        }
      };

      script.onerror = reject;
      document.head.appendChild(script);
    }).catch((error) => {
      loader = undefined;
      throw error;
    });

    return loader;
  };

  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const generation = this.generation =
        (this.generation || 0) + 1;

      const target = this.querySelector(
        '[data-home-hubspot-target]'
      );

      const status = this.querySelector(
        '[data-home-hubspot-status]'
      );

      const error = this.querySelector(
        '[data-home-hubspot-error]'
      );

      status.hidden = false;
      error.hidden = true;

      const fail = () => {
        if (
          !this.isConnected ||
          generation !== this.generation
        ) return;

        status.hidden = true;
        error.hidden = false;
      };

      this.observer = new MutationObserver(() => {
        target.querySelectorAll('iframe').forEach((frame) => {
          frame.style.width = '100%';
          frame.style.maxWidth = '100%';
          frame.style.border = '0';
          frame.style.display = 'block';
        });

        if (
          target.querySelector('form,iframe,.submitted-message')
        ) {
          status.hidden = true;
          error.hidden = true;
          clearTimeout(this.timeout);
          this.observer.disconnect();
        }
      });

      this.observer.observe(target, {
        childList: true,
        subtree: true
      });

      this.timeout = setTimeout(fail, 20000);

      load().then(() => {
        if (
          !this.isConnected ||
          generation !== this.generation
        ) return;

        window.hbspt.forms.create({
          portalId: '6633929',
          formId: 'f9b18428-61c9-476c-9f5f-e75b2d022b32',
          region: 'na1',
          target: '#' + CSS.escape(target.id),
          formInstanceId: target.id,
          css:
            'body { font-family:' +
            getComputedStyle(this).fontFamily +
            '; }' +
            this.querySelector('[data-home-hubspot-css]')
              .content.textContent
        });
      }).catch(fail);
    }

    disconnectedCallback() {
      this.generation = (this.generation || 0) + 1;
      clearTimeout(this.timeout);
      this.observer?.disconnect();
      this.initialized = false;

      this.querySelector('[data-home-hubspot-target]')
        ?.replaceChildren();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-makes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ap-carousel')) {
    customElements.define('ap-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.track = this.querySelector('[data-carousel-track]');
        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));

        if (!this.track || this.slides.length < 2) return;

        this.index = 0;
        this.direction = this.dataset.direction === 'right' ? -1 : 1;

        const area = this.closest('.ap-makes, .ap-review-section');

        area?.querySelector('[data-carousel-prev]')?.addEventListener('click', () => this.go(-1));
        area?.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.go(1));

        const dots = this.querySelector('[data-carousel-dots]');

        if (dots) {
          this.slides.forEach((slide, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
            dot.addEventListener('click', () => this.goTo(index));
            dots.appendChild(dot);
          });
        }

        this.updateDots();

        this.track.addEventListener('scroll', () => {
          window.clearTimeout(this.scrollTimer);
          this.scrollTimer = window.setTimeout(() => this.syncIndex(), 80);
        }, { passive: true });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        this.start();
      }

      go(step) {
        this.goTo((this.index + step + this.slides.length) % this.slides.length);
      }

      goTo(index) {
        this.index = index;
        const target = this.track.scrollLeft + this.slides[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollTo({ left: target, behavior: 'smooth' });
        this.updateDots();
      }

      syncIndex() {
        const left = this.track.getBoundingClientRect().left;
        let best = 0;
        let distance = Infinity;

        this.slides.forEach((slide, index) => {
          const current = Math.abs(slide.getBoundingClientRect().left - left);

          if (current < distance) {
            distance = current;
            best = index;
          }
        });

        this.index = best;
        this.updateDots();
      }

      updateDots() {
        this.querySelectorAll('[data-carousel-dots] button').forEach((dot, index) => {
          dot.classList.toggle('is-active', index === this.index);
        });
      }

      start() {
        this.stop();

        if (this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.timer = window.setInterval(() => this.go(this.direction), Number(this.dataset.speed) || 4000);
      }

      stop() {
        window.clearInterval(this.timer);
      }

      disconnectedCallback() {
        this.stop();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autopair-car-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tag = 'goofy-hubspot-hero';
    if (customElements.get(tag)) return;

    let loader;

    const loadHubSpot = () => {
      if (window.hbspt?.forms?.create) {
        return Promise.resolve();
      }

      if (loader) return loader;

      loader = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://js.hsforms.net/forms/embed/v2.js';
        script.charset = 'utf-8';
        script.async = true;

        script.onload = () => {
          if (window.hbspt?.forms?.create) {
            resolve();
          } else {
            reject();
          }
        };

        script.onerror = reject;
        document.head.appendChild(script);
      }).catch((error) => {
        loader = undefined;
        throw error;
      });

      return loader;
    };

    customElements.define(tag, class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;

        const generation = this.generation =
          (this.generation || 0) + 1;

        const target = this.querySelector('[data-hubspot-target]');
        const status = this.querySelector('[data-hubspot-status]');
        const fallback = this.querySelector('[data-hubspot-fallback]');

        const showError = () => {
          if (
            generation !== this.generation ||
            !this.isConnected
          ) return;

          status.hidden = true;
          fallback.hidden = false;
        };

        this.observer = new MutationObserver(() => {
          if (
            target.querySelector('iframe,form,.submitted-message')
          ) {
            status.hidden = true;
            fallback.hidden = true;
            clearTimeout(this.timeout);
            this.observer.disconnect();
          }
        });

        this.observer.observe(target, {
          childList: true,
          subtree: true
        });

        this.timeout = setTimeout(showError, 20000);

        loadHubSpot().then(() => {
          if (
            !this.isConnected ||
            generation !== this.generation
          ) return;

          window.hbspt.forms.create({
            portalId: this.dataset.portal,
            formId: this.dataset.form,
            region: this.dataset.region,
            target: '#' + CSS.escape(target.id),
            formInstanceId: target.id,
            css:
              'body { font-family:' +
              getComputedStyle(this).fontFamily +
              '; }' +
              this.querySelector('[data-hubspot-css]')
                .content.textContent
          });
        }).catch(showError);
      }

      disconnectedCallback() {
        this.generation = (this.generation || 0) + 1;
        clearTimeout(this.timeout);
        this.observer?.disconnect();
        this.initialized = false;

        this.querySelector('[data-hubspot-target]')
          ?.replaceChildren();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autopair-pricing-tilt"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ap-pricing-tilt')) {
    customElements.define('ap-pricing-tilt', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.frames = new Set();

        const reduced = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        if (
          this.dataset.tilt === 'true' &&
          window.matchMedia(
            '(hover: hover) and (pointer: fine)'
          ).matches
        ) {
          this.querySelectorAll('.ap-pricing__stage').forEach((stage) => {
            let frame = 0;

            const reset = () => {
              cancelAnimationFrame(frame);
              this.frames.delete(frame);
              frame = 0;

              stage.classList.remove('is-tracking');
              stage.style.removeProperty('--apt-rx');
              stage.style.removeProperty('--apt-ry');
            };

            stage.addEventListener('pointermove', (event) => {
              if (
                reduced.matches ||
                event.pointerType !== 'mouse'
              ) return;

              const rect = stage.getBoundingClientRect();

              const x = Math.max(
                -.5,
                Math.min(
                  .5,
                  (event.clientX - rect.left) / rect.width - .5
                )
              );

              const y = Math.max(
                -.5,
                Math.min(
                  .5,
                  (event.clientY - rect.top) / rect.height - .5
                )
              );

              cancelAnimationFrame(frame);
              this.frames.delete(frame);

              frame = requestAnimationFrame(() => {
                this.frames.delete(frame);
                stage.classList.add('is-tracking');
                stage.style.setProperty('--apt-rx', `${-y * 12}deg`);
                stage.style.setProperty('--apt-ry', `${x * 12}deg`);
              });

              this.frames.add(frame);
            }, options);

            stage.addEventListener('pointerleave', reset, options);
            reduced.addEventListener('change', reset, options);
          });
        }

        this.addEventListener('click', (event) => {
          const link = event.target.closest('.ap-pricing__button');

          if (
            !link ||
            event.defaultPrevented ||
            event.button !== 0 ||
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey
          ) return;

          const url = new URL(link.href, window.location.href);

          if (
            url.origin !== location.origin ||
            url.pathname !== location.pathname ||
            url.search !== location.search ||
            !url.hash
          ) return;

          let id;

          try {
            id = decodeURIComponent(url.hash.slice(1));
          } catch {
            return;
          }

          const target = document.getElementById(id);
          if (!target) return;

          event.preventDefault();

          const top =
            target.getBoundingClientRect().top +
            window.scrollY -
            (Number(this.dataset.offset) || 0);

          window.scrollTo({
            top: Math.max(0, top),
            behavior: reduced.matches ? 'auto' : 'smooth'
          });
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;

        this.frames?.forEach((frame) => {
          cancelAnimationFrame(frame);
        });

        this.querySelectorAll('.ap-pricing__stage').forEach((stage) => {
          stage.classList.remove('is-tracking');
          stage.style.removeProperty('--apt-rx');
          stage.style.removeProperty('--apt-ry');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autopair-process-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeTabs = (root) => {
      if (!root || root.dataset.tabsReady === 'true') return;

      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
      if (!tabs.length || !panels.length) return;

      root.dataset.tabsReady = 'true';
      root.style.setProperty('--apt-tab-count', tabs.length);

      const activateTab = (tab, moveFocus = true) => {
        const index = Number(tab.dataset.tabIndex);

        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
          const active = Number(panel.dataset.panelIndex) === index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });

        if (window.matchMedia('(min-width: 750px)').matches) {
  tab.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth',
    block: 'nearest',
    inline: 'center'
  });
}
        if (moveFocus) tab.focus({ preventScroll: true });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab, false));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === index && !['Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          activateTab(tabs[nextIndex]);
        });
      });

      root.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-panel-index]');
        if (panel) activateTab(tabs[Number(panel.dataset.panelIndex)], false);
      });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-autopair-tabs]').forEach(initializeTabs);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autopair-submission-portal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tag = 'goofy-portal-hubspot';
    if (customElements.get(tag)) return;

    let loader;

    const loadHubSpot = () => {
      if (window.hbspt?.forms?.create) return Promise.resolve();
      if (loader) return loader;

      loader = new Promise((resolve, reject) => {
        let script = Array.from(document.scripts).find((item) =>
          /js(?:-na1)?\.hsforms\.net\/forms\/embed\/v2\.js/.test(item.src)
        );

        const existing = Boolean(script);

        if (!script) {
          script = document.createElement('script');
          script.src = 'https://js.hsforms.net/forms/embed/v2.js';
          script.charset = 'utf-8';
          script.async = true;
        }

        let poll;

        const cleanup = () => {
          clearInterval(poll);
          clearTimeout(timeout);
          script.removeEventListener('error', fail);
        };

        const fail = () => {
          cleanup();
          reject(new Error('HubSpot could not load.'));
        };

        const timeout = setTimeout(fail, 20000);

        poll = setInterval(() => {
          if (window.hbspt?.forms?.create) {
            cleanup();
            resolve();
          }
        }, 100);

        script.addEventListener('error', fail, { once: true });

        if (!existing) document.head.appendChild(script);
      }).catch((error) => {
        loader = undefined;
        throw error;
      });

      return loader;
    };

    customElements.define(tag, class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;

        const target = this.querySelector('[data-portal-hubspot-target]');
        const status = this.querySelector('[data-portal-hubspot-status]');
        const error = this.querySelector('[data-portal-hubspot-error]');

        if (!target) return;

        const fail = () => {
          if (!this.isConnected) return;
          status.hidden = true;
          error.hidden = false;
        };

        loadHubSpot().then(() => {
          if (!this.isConnected) {
            this.started = false;
            return;
          }

          const ready = () => {
            if (target.querySelector('iframe, form, .submitted-message')) {
              status.hidden = true;
              error.hidden = true;
              this.observer?.disconnect();
            }
          };

          this.observer = new MutationObserver(ready);
          this.observer.observe(target, {
            childList: true,
            subtree: true
          });

          window.hbspt.forms.create({
            portalId: '6633929',
            formId: 'f9838a29-7ce1-4648-929b-3d5e0dafb472',
            region: 'na1',
            target: '#' + target.id,
            formInstanceId: target.id,
            onFormReady: () => {
              status.hidden = true;
              error.hidden = true;
              this.observer?.disconnect();
            }
          });

          ready();
        }).catch(fail);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autopair-vehicle-makes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ap-vehicle-carousel')) {
    customElements.define('ap-vehicle-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.track = this.querySelector('[data-apvm-track]');
        this.slides = Array.from(this.querySelectorAll('[data-apvm-slide]'));
        this.section = this.closest('[data-apvm-section]');
        this.previous = this.section?.querySelector('[data-apvm-prev]');
        this.next = this.section?.querySelector('[data-apvm-next]');
        this.dots = this.querySelector('[data-apvm-dots]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleVisibility = () => {
          if (document.hidden) this.stop();
          else this.start();
        };
        this.handleMotionPreference = () => this.start();
        this.index = 0;
        this.direction = this.dataset.direction === 'right' ? -1 : 1;

        if (!this.track || this.slides.length < 2) return;

        if (this.previous) this.previous.addEventListener('click', () => this.manualGo(-1));
        if (this.next) this.next.addEventListener('click', () => this.manualGo(1));

        if (this.dots) {
          this.slides.forEach((slide, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', `Go to vehicle logo ${index + 1}`);
            dot.addEventListener('click', () => {
              this.goTo(index);
              this.restart();
            });
            this.dots.appendChild(dot);
          });
        }

        this.track.addEventListener('scroll', () => {
          window.clearTimeout(this.scrollTimer);
          this.scrollTimer = window.setTimeout(() => this.syncIndex(), 80);
        }, { passive: true });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.start();
        });
        this.track.addEventListener('pointerdown', () => this.stop());
        this.track.addEventListener('pointerup', () => this.start());
        this.track.addEventListener('pointercancel', () => this.start());
        this.reducedMotion.addEventListener('change', this.handleMotionPreference);
        document.addEventListener('visibilitychange', this.handleVisibility);

        this.updateDots();
        this.start();
      }

      manualGo(step) {
        this.go(step);
        this.restart();
      }

      go(step) {
        this.goTo((this.index + step + this.slides.length) % this.slides.length);
      }

      goTo(index) {
        this.index = index;
        const trackLeft = this.track.getBoundingClientRect().left;
        const slideLeft = this.slides[index].getBoundingClientRect().left;
        const target = this.track.scrollLeft + slideLeft - trackLeft;
        this.track.scrollTo({ left: target, behavior: 'smooth' });
        this.updateDots();
      }

      syncIndex() {
        const trackLeft = this.track.getBoundingClientRect().left;
        let closestIndex = 0;
        let closestDistance = Infinity;

        this.slides.forEach((slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.index = closestIndex;
        this.updateDots();
      }

      updateDots() {
        this.querySelectorAll('[data-apvm-dots] button').forEach((dot, index) => {
          dot.classList.toggle('is-active', index === this.index);
          dot.setAttribute('aria-current', index === this.index ? 'true' : 'false');
        });
      }

      start() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.reducedMotion.matches || document.hidden) return;
        this.timer = window.setInterval(() => this.go(this.direction), Number(this.dataset.speed) || 4000);
      }

      stop() {
        window.clearInterval(this.timer);
      }

      restart() {
        this.stop();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        window.clearTimeout(this.scrollTimer);
        this.reducedMotion?.removeEventListener('change', this.handleMotionPreference);
        document.removeEventListener('visibilitychange', this.handleVisibility);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autopair-warranty-comparison"] && !Shopify.designMode) return;
  try {
    
(() => {
  const states = new WeakMap();
  const controllers = new WeakMap();
  let hubspotLoader;

  const loadHubSpot = () => {
    if (window.hbspt?.forms?.create) {
      return Promise.resolve();
    }

    if (hubspotLoader) return hubspotLoader;

    hubspotLoader = new Promise((resolve, reject) => {
      const script = document.createElement('script');

      script.src = 'https://js.hsforms.net/forms/embed/v2.js';
      script.charset = 'utf-8';
      script.async = true;

      script.onload = () => {
        if (window.hbspt?.forms?.create) {
          resolve();
        } else {
          reject(new Error('Unable to load HubSpot.'));
        }
      };

      script.onerror = () => {
        reject(new Error('Unable to load HubSpot.'));
      };

      document.head.appendChild(script);
    }).catch((error) => {
      hubspotLoader = null;
      throw error;
    });

    return hubspotLoader;
  };

  const addCalendarSpace = (target) => {
  target
    .querySelectorAll('iframe.hs-form-iframe, iframe[id^="hs-form-iframe"]')
    .forEach((frame) => {
      if (frame.style.minHeight) {
        frame.style.removeProperty('min-height');
      }
    });
};

  const loadForm = async (panel) => {
    let state = states.get(panel);

    if (state?.created || state?.loading) {
      addCalendarSpace(panel);
      return;
    }

    const target = panel.querySelector('[data-form-target]');
    const status = panel.querySelector('[data-form-loading]');
    const error = panel.querySelector('[data-form-error]');

    state = {
      loading:true,
      created:false,
      observer:null,
      resizeFrame:0
    };

    states.set(panel, state);

    status.hidden = false;
    error.hidden = true;

    try {
      await loadHubSpot();

      if (!panel.isConnected) return;

      state.observer = new MutationObserver(() => {
        if (target.querySelector('form,iframe,.submitted-message')) {
          status.hidden = true;
        }

        cancelAnimationFrame(state.resizeFrame);

        state.resizeFrame = requestAnimationFrame(() => {
          addCalendarSpace(target);
        });
      });

      state.observer.observe(target, {
        childList:true,
        subtree:true,
        attributes:true,
        attributeFilter:['height','style']
      });

      window.hbspt.forms.create({
        portalId:'6633929',
        formId:panel.dataset.hubspotForm,
        region:'na1',
        target:'#' + CSS.escape(target.id),
        formInstanceId:target.id,

        onFormReady:() => {
          status.hidden = true;

          requestAnimationFrame(() => {
            addCalendarSpace(target);
          });
        }
      });

      state.created = true;
    } catch (loadError) {
      state.observer?.disconnect();
      target.replaceChildren();

      status.hidden = true;
      error.hidden = false;
    } finally {
      state.loading = false;
    }
  };

  const initialize = (root) => {
    if (controllers.has(root)) return;

    const abort = new AbortController();
    controllers.set(root, abort);

    const options = {
      signal:abort.signal
    };

    const dialog = root.querySelector('[data-plan-dialog]');
    const panels = Array.from(
      root.querySelectorAll('[data-plan-embed]')
    );

    const closeInfoPopups = (except = null) => {
      root.querySelectorAll('.warranty-compare__info-wrap.is-open')
        .forEach((wrapper) => {
          if (wrapper === except) return;

          wrapper.classList.remove('is-open');

          wrapper.querySelector('[data-info-trigger]')
            ?.setAttribute('aria-expanded', 'false');
        });
    };

    root.querySelectorAll('[data-info-trigger]').forEach((trigger) => {
      trigger.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') {
          event.preventDefault();
        }
      }, options);

      trigger.addEventListener('click', () => {
        if (!window.matchMedia('(hover: none)').matches) return;

        const wrapper = trigger.closest('.warranty-compare__info-wrap');
        const open = !wrapper.classList.contains('is-open');

        closeInfoPopups(wrapper);

        wrapper.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', String(open));
      }, options);
    });

    document.addEventListener('click', (event) => {
      if (
        !root.contains(event.target) ||
        !event.target.closest('.warranty-compare__info-wrap')
      ) {
        closeInfoPopups();
      }
    }, options);

    root.querySelectorAll('[data-select-plan]').forEach((button) => {
      button.addEventListener('click', () => {
        const panel = panels.find(
          (item) => item.dataset.planEmbed === button.dataset.planIndex
        );

        if (!panel) return;

        panels.forEach((item) => {
          item.hidden = item !== panel;
        });

        root.querySelector('[data-selected-plan]').textContent =
          button.dataset.planName;

        if (!dialog.open) {
          dialog.showModal();
        }

        dialog.scrollTop = 0;
        loadForm(panel);
      }, options);
    });

    panels.forEach((panel) => {
      panel.querySelector('[data-form-retry]')
        .addEventListener('click', () => {
          loadForm(panel);
        }, options);
    });

    root.querySelector('[data-close-dialog]')
      .addEventListener('click', () => {
        dialog.close();
      }, options);

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    }, options);

    window.addEventListener('resize', () => {
      if (dialog.open) {
        panels
          .filter((panel) => !panel.hidden)
          .forEach(addCalendarSpace);
      }
    }, options);
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-warranty-compare]')
      .forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll(),
      { once:true }
    );
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-warranty-compare]')
      .forEach((root) => {
        controllers.get(root)?.abort();
        controllers.delete(root);

        root.querySelectorAll('[data-plan-embed]')
          .forEach((panel) => {
            const state = states.get(panel);

            state?.observer?.disconnect();

            if (state) {
              cancelAnimationFrame(state.resizeFrame);
            }
          });
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["optimized-video-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const track = root.querySelector('[data-review-track]');
      const previous = root.querySelector('[data-review-prev]');
      const next = root.querySelector('[data-review-next]');
      const progress = root.querySelector('[data-review-progress]');
      const googleReviewsUrl = root.dataset.googleReviewsUrl;
      const autoplayEnabled = root.dataset.autoplay === 'true';
      const autoplaySpeed = Number(root.dataset.autoplaySpeed) || 5000;
      const autoplayDirection = root.dataset.autoplayDirection === 'right' ? -1 : 1;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let autoplayTimer = null;

      if (googleReviewsUrl) {
        root.querySelectorAll('[data-google-review-link]').forEach((element) => {
          let pointerStart = null;
          let pointerMoved = false;
          element.addEventListener('pointerdown', (event) => {
            pointerStart = { x: event.clientX, y: event.clientY };
            pointerMoved = false;
          });
          element.addEventListener('pointermove', (event) => {
            if (!pointerStart) return;
            if (Math.abs(event.clientX - pointerStart.x) > 8 || Math.abs(event.clientY - pointerStart.y) > 8) pointerMoved = true;
          });
          element.addEventListener('pointercancel', () => {
            pointerStart = null;
            pointerMoved = false;
          });
          element.addEventListener('click', (event) => {
            if (pointerMoved || event.target.closest('a, button, iframe, video')) {
              pointerStart = null;
              pointerMoved = false;
              return;
            }
            pointerStart = null;
            window.open(googleReviewsUrl, '_blank', 'noopener,noreferrer');
          });
          element.addEventListener('keydown', (event) => {
            if (event.target !== element || (event.key !== 'Enter' && event.key !== ' ')) return;
            event.preventDefault();
            window.open(googleReviewsUrl, '_blank', 'noopener,noreferrer');
          });
        });
      }

      if (!track || !previous || !next) return;

      const cardWidth = () => {
        const card = track.querySelector('.video-reviews__card');
        if (!card) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      };
      const updateProgress = () => {
        const maximum = track.scrollWidth - track.clientWidth;
        const percentage = maximum > 0 ? (track.scrollLeft / maximum) * 100 : 100;
        if (progress) progress.style.width = `${Math.max(8, percentage)}%`;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
      };

      const stopAutoplay = () => {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      };

      const moveAutoplay = () => {
        const maximum = track.scrollWidth - track.clientWidth;
        if (maximum <= 2) return;

        if (autoplayDirection > 0) {
          if (track.scrollLeft >= maximum - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
          else track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
        } else if (track.scrollLeft <= 2) {
          track.scrollTo({ left: maximum, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
        }
      };

      const startAutoplay = () => {
        stopAutoplay();
        if (!autoplayEnabled || reducedMotion.matches || document.hidden || track.children.length < 2) return;
        autoplayTimer = window.setInterval(moveAutoplay, autoplaySpeed);
      };

      const restartAutoplay = () => {
        stopAutoplay();
        startAutoplay();
      };

      previous.addEventListener('click', () => {
        track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
        restartAutoplay();
      });
      next.addEventListener('click', () => {
        track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
        restartAutoplay();
      });
      track.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress, { passive: true });
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) startAutoplay();
      });
      track.addEventListener('pointerdown', stopAutoplay);
      track.addEventListener('pointerup', startAutoplay);
      track.addEventListener('pointercancel', startAutoplay);
      reducedMotion.addEventListener('change', startAutoplay);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });
      updateProgress();
      startAutoplay();
    };

    const initializeAll = (scope = document) => scope.querySelectorAll('[data-video-reviews]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const form = root.querySelector('[data-details-form]');
      if (!form) return;
      const errorSummary = root.querySelector('[data-error-summary]');
      const errorList = root.querySelector('[data-error-list]');
      const saveButton = root.querySelector('[data-save-details]');
      const saveStatus = root.querySelector('[data-save-status]');
      const checkoutButton = root.querySelector('[data-checkout]');
      const warrantyToggle = root.querySelector('[data-manufacturer-warranty]');
      const warrantyFields = root.querySelector('[data-manufacturer-fields]');
      const warrantyDetails = root.querySelectorAll('[data-manufacturer-detail]');
      const paymentToggle = root.querySelector('[data-payment-toggle]');
      const paymentForm = root.querySelector('[data-payment-form]');
      let isSaved = form.querySelectorAll('[required]').length > 0 && Array.from(form.querySelectorAll('[required]')).every((field) => field.value.trim() !== '');

      const fieldLabel = (field) => field.closest('label')?.querySelector('span')?.textContent.replace('*', '').trim() || field.name;

      const updateWarrantyFields = () => {
        const active = warrantyToggle.checked;
        warrantyFields.hidden = !active;
        warrantyDetails.forEach((field) => {
          field.disabled = !active;
          field.required = active;
          if (!active) field.value = '';
        });
      };

      const showErrors = () => {
        const invalidFields = Array.from(form.querySelectorAll(':invalid'));
        form.querySelectorAll('.is-invalid').forEach((field) => field.classList.remove('is-invalid'));
        errorList.innerHTML = '';
        invalidFields.forEach((field) => {
          field.classList.add('is-invalid');
          field.setAttribute('aria-invalid', 'true');
          const item = document.createElement('li');
          item.textContent = `${fieldLabel(field)} is a required field.`;
          errorList.appendChild(item);
        });
        if (invalidFields.length) {
          errorSummary.hidden = false;
          errorSummary.focus();
          errorSummary.scrollIntoView({ behavior: 'smooth', block: 'start' });
          invalidFields[0].focus({ preventScroll: true });
          return false;
        }
        errorSummary.hidden = true;
        return true;
      };

      const collectAttributes = () => {
        const attributes = {};
        new FormData(form).forEach((value, key) => { attributes[key] = value; });
        attributes['Manufacturer warranty'] = warrantyToggle.checked ? 'Yes' : 'No';
        attributes['Selected Warranty Variant ID'] = root.dataset.selectedVariantId;
        if (!warrantyToggle.checked) {
          attributes['Manufacturer warranty term'] = '';
          attributes['Manufacturer warranty KM'] = '';
          attributes['In service date'] = '';
        }
        return attributes;
      };

      const saveDetails = async () => {
        if (!showErrors()) return false;
        saveButton.disabled = true;
        saveStatus.classList.remove('is-error');
        saveStatus.textContent = 'Saving details…';
        try {
          const response = await fetch(root.dataset.cartUpdateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: collectAttributes() })
          });
          if (!response.ok) throw new Error('Your details could not be saved. Please try again.');
          isSaved = true;
          saveStatus.textContent = 'Details saved. You can now continue to checkout.';
          return true;
        } catch (error) {
          isSaved = false;
          saveStatus.classList.add('is-error');
          saveStatus.textContent = error.message;
          return false;
        } finally {
          saveButton.disabled = false;
        }
      };

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        await saveDetails();
      });

      form.addEventListener('input', (event) => {
        isSaved = false;
        saveStatus.textContent = '';
        event.target.classList.remove('is-invalid');
        event.target.removeAttribute('aria-invalid');
      });

      warrantyToggle.addEventListener('change', updateWarrantyFields);
      updateWarrantyFields();

      paymentToggle?.addEventListener('click', () => {
        const open = paymentForm.hidden;
        paymentForm.hidden = !open;
        paymentToggle.setAttribute('aria-expanded', String(open));
      });

      checkoutButton.addEventListener('click', async () => {
        if (!showErrors()) return;
        if (!isSaved) {
          const saved = await saveDetails();
          if (!saved) return;
        }
        checkoutButton.disabled = true;
        checkoutButton.textContent = 'Opening secure checkout…';
        window.location.assign(root.dataset.checkoutUrl);
      });
    };

    const initializeAll = (scope = document) => scope.querySelectorAll('[data-warranty-details]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
